import './careers.css';
import React from 'react';

const SoftwareText = () => {
  return (
    <div>
      <p className="text">
        We build dedicated software applications focused on managing our
        users and controlling our vehicles. We use advanced algorithms to
        connect our vehicles to multiple ridesharing platforms, maximize
        the efficiency of our operations and to allow our model to scale
        globally.
      </p>
    </div>
  );
};

export default SoftwareText;



// WEBPACK FOOTER //
// ./src/components/Careers/SoftwareText.js